import { render, staticRenderFns } from "./GOverlay.vue?vue&type=template&id=3879e72c&scoped=true"
import script from "./GOverlay.vue?vue&type=script&lang=js"
export * from "./GOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3879e72c",
  null
  
)

export default component.exports